import React, { useContext } from "react";
import Layout from '../../Components/VC/VcCompanyLayout'
import MainMenu from '../../Components/VC/Mainmenu'
import Card from '../../Components/ListPageCard/IpoCard'
import Table from '../../Components/TableComponent'
// import {PE_TABLE_QUERY} from '../../Queries/Pe';

import RefineSearch from '../../Components/RefineSearchComponent'
import FilterTag from '../../Components/Tag'
// import chatPopupIcon from '../../images/chatPopupIcon.png'
// import ChatPopup from '../../Components/ChatPopup'
import Constants from '../../Constants'
import BackedIPORefineSearch from '../../Components/RefineSearch/BackedIPORefineSearch'
import { useLocation } from "react-router";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { Switch, Tooltip } from "antd";
/**
 * The function `BackedIpoVc` is a React component that renders a layout with a top navigation bar, a
 * sidebar, and a main content area, which includes a filter tag, a main menu, and a table.
 * @returns The function `BackedIpoVc` returns JSX elements wrapped in a `Layout` component. The
 * returned JSX structure includes a top navigation section, a bottom section with a narrow sidebar and
 * a main area, and a secondary column (hidden on smaller screens). The main area includes a primary
 * column and a secondary column. The primary column contains a section with content, including a
 * `FilterTag`
 */
function BackedIpoVc() {
    // const [showModal, setShowModal] = React.useState(false);
    const location = useLocation(); 
    const { pathname } = useLocation(); 
 
    const { refineSearchFilters, dealsView, setDealsView, switchValue, setSwitchValue  } = useContext(PeFilterContext);
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    const dealsViewHandler = (checked) =>{
        setSwitchValue(checked);
        if(checked){ setDealsView(true) }else setDealsView(false);
    }

    return (
        <Layout>
         <div className="flex h-screen flex-col">
                    {/* Top nav*/}
                    {isFromGlobalSearch () ? "" :<div className="hidden lg:block"><Card /> </div>}
                    {/* Bottom section */}
                    <div className="flex min-h-0 flex-1">
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "mt-[3rem] min-w-0 flex-1 border-t border-gray-200 lg:flex":"min-w-0 flex-1 border-t border-gray-200 lg:flex"}>
                            {/* Primary column */}
                            <section
                                className="flex h-full min-w-0 flex-1 overflow-y-auto flex-col lg:order-last">
                                {/* Your content */}
                                <div className="mr-16 flex justify-between items-center">
                                <FilterTag />
                                <Tooltip title={`${dealsView ? 'Toggle Companies View' : 'Toggle Deals View'}`}>
                                    <Switch onChange={dealsViewHandler} checked={switchValue}/>
                                </Tooltip>
                                </div>
                                <MainMenu active={3} menu="VC-IPOs" primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                subTypeMasterId={Constants.primaryMasterSubIds.vc_backed_ipos_id}
                                typeId={Constants.moduleIds.companiesId}
                                exportFileName={Constants.exportNames.vc_company_ipo}/>
                                <div className='overflow-y-auto'>
                                    <Table menu="backedIpos-vc" sub_type_master_id={Constants.subCategoryIds.vc_backed_ipos_id}/>
                                </div>
                            </section>
                            {/* Secondary column (hidden on smaller screens) */}
                            <aside className="hidden lg:order-first lg:block lg:flex-shrink-0">
                                <div className="relative flex flex-col border-r border-gray-200 bg-[#FAF5EA]">
                                    {/* Your content */}
                                    <RefineSearch>
                                        <BackedIPORefineSearch customPathname={location.pathname}/>
                                    </RefineSearch>
                                </div>
                            </aside>
                        </main>
                    </div>
                   
                </div>
        </Layout>
    )
}

export default BackedIpoVc
